var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("div", { staticClass: "page-title" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              _vm.isEdit
                ? "operation.edit_franchisee"
                : "operation.create_franchisee"
            )
          )
        ),
      ]),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          staticClass: "form-content",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "170px" },
        },
        [
          _vm.isEdit
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("operation.franchisee_no") } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.franchisee_no,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "franchisee_no", $$v)
                      },
                      expression: "form.franchisee_no",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("operation.franchisee_name"),
                prop: "franchisee_name",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "128",
                  "show-word-limit": "",
                  placeholder: _vm.$t("operation.enter_franchisee_name"),
                },
                model: {
                  value: _vm.form.franchisee_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "franchisee_name", $$v)
                  },
                  expression: "form.franchisee_name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("operation.region"),
                prop: "country_code",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    disabled: _vm.isEdit,
                    loading: _vm.regionLoading,
                    placeholder: _vm.$t("operation.select_region"),
                  },
                  on: { change: _vm.onRegionChange },
                  model: {
                    value: _vm.form.country_code,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "country_code", $$v)
                    },
                    expression: "form.country_code",
                  },
                },
                _vm._l(_vm.regionOptions, function (region) {
                  return _c("el-option", {
                    key: region.value,
                    attrs: { label: region.label, value: region.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("operation.currency"), prop: "currency" },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    disabled: _vm.isEdit || !_vm.form.country_code,
                    placeholder: _vm.$t("operation.select_currency"),
                  },
                  model: {
                    value: _vm.form.currency,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "currency", $$v)
                    },
                    expression: "form.currency",
                  },
                },
                _vm._l(_vm.currencyOptions, function (currencyOption) {
                  return _c("el-option", {
                    key: currencyOption,
                    attrs: { label: currencyOption, value: currencyOption },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("operation.remark"), prop: "remark" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "128",
                  "show-word-limit": "",
                  placeholder: _vm.$t("operation.enter_remark"),
                },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("operation.contact_name"),
                prop: "contact_name",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "32",
                  "show-word-limit": "",
                  placeholder: _vm.$t("operation.enter_contact_name"),
                },
                model: {
                  value: _vm.form.contact_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "contact_name", $$v)
                  },
                  expression: "form.contact_name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("operation.contact_phone"),
                prop: "contact_phone",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "16",
                  "show-word-limit": "",
                  placeholder: _vm.$t("operation.enter_phone"),
                },
                model: {
                  value: _vm.form.contact_phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "contact_phone", $$v)
                  },
                  expression: "form.contact_phone",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("operation.contact_email"),
                prop: "contact_email",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "32",
                  "show-word-limit": "",
                  placeholder: _vm.$t("operation.enter_email"),
                },
                model: {
                  value: _vm.form.contact_email,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "contact_email", $$v)
                  },
                  expression: "form.contact_email",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("operation.description"),
                prop: "description",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  maxlength: "512",
                  "show-word-limit": "",
                  placeholder: _vm.$t("operation.enter_description"),
                },
                model: {
                  value: _vm.form.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$router.back()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.cancel")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v(_vm._s(_vm.$t("components.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.confirmDialogVisible,
            title: _vm.$t("operation.confirm_submit"),
            width: "560px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.confirmDialogVisible = $event
            },
          },
        },
        [
          _c("p", { staticClass: "confirm-description" }, [
            _vm._v(_vm._s(_vm.$t("operation.confirm_franchisee"))),
          ]),
          _c(
            "el-descriptions",
            {
              staticClass: "confirm-details",
              attrs: { column: 1, border: "" },
            },
            [
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("operation.franchisee_name") } },
                [_vm._v(_vm._s(_vm.form.franchisee_name))]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("operation.region") } },
                [_vm._v(_vm._s(_vm.selectedRegionLabel))]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("operation.currency") } },
                [_vm._v(_vm._s(_vm.form.currency))]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("operation.remark") } },
                [_vm._v(_vm._s(_vm.form.remark || "-"))]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("operation.contact_name") } },
                [_vm._v(_vm._s(_vm.form.contact_name || "-"))]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("operation.contact_phone") } },
                [_vm._v(_vm._s(_vm.form.contact_phone || "-"))]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("operation.contact_email") } },
                [_vm._v(_vm._s(_vm.form.contact_email || "-"))]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("operation.description") } },
                [_vm._v(_vm._s(_vm.form.description || "-"))]
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.confirmDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitting },
                  on: { click: _vm.confirmSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("components.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }